export enum PackageDuration {
  PerDay = 0,
  PerMonth = 1,
  PerYear = 2,
}
